import { Injectable, signal } from '@angular/core';

export type ColorScheme = 'light' | 'dark';

const COLOR_SCHEME_KEY = 'cuminanza:colorScheme';

@Injectable({ providedIn: 'root' })
export class AppearanceService {
  readonly colorScheme = signal<ColorScheme>(this.loadColorScheme());

  init(): void {
    this.applyColorScheme(this.colorScheme());
  }

  setColorScheme(scheme: ColorScheme): void {
    this.colorScheme.set(scheme);
    localStorage.setItem(COLOR_SCHEME_KEY, scheme);
    this.applyColorScheme(scheme);
  }

  private loadColorScheme(): ColorScheme {
    const stored = localStorage.getItem(COLOR_SCHEME_KEY);
    return stored === 'dark' ? 'dark' : 'light';
  }

  private applyColorScheme(scheme: ColorScheme): void {
    document.body.classList.toggle('dark', scheme === 'dark');
  }
}
